(() => {
  'use strict';
  if (window.fiaRegionalColorsStarted) return;
  window.fiaRegionalColorsStarted = true;
  const start = () => {
    const data = window.FIARegionalColors;
    if (!data) return;
    const style = document.createElement('style');
    style.textContent = `.fia-selected-color{display:flex;align-items:center;gap:1rem;margin:.8rem 0 0;font-size:1.4rem;line-height:1.5}.fia-selected-color__chip{flex:0 0 3.2rem;width:3.2rem;height:3.2rem;border-radius:50%;border:2px solid #999;box-shadow:0 0 0 2px rgb(var(--color-background));background:var(--fia-swatch,#888)}.fia-selected-color small{display:block;font-size:1.2rem;font-weight:400;opacity:.8}.fia-photo-message{padding:1.2rem;border:1px solid currentColor;line-height:1.6}.fia-photo-message[hidden],.new-regional-static-card[hidden],.new-regional-static__product-image[hidden]{display:none!important}.fia-selected-color__name{font-weight:600}`;
    document.head.append(style);
    const swatch = () => {
      const element = document.createElement('div');
      element.className = 'fia-selected-color';
      element.setAttribute('aria-live', 'polite');
      const chip = document.createElement('span');
      chip.className = 'fia-selected-color__chip';
      chip.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      const name = document.createElement('span');
      name.className = 'fia-selected-color__name';
      const help = document.createElement('small');
      help.textContent = 'Approximate screen color';
      text.append(name, help);
      element.append(chip, text);
      return element;
    };
    const paint = (element, color) => {
      element.style.setProperty('--fia-swatch', data.c[color] || '#888888');
      element.querySelector('.fia-selected-color__name').textContent = color;
    };

    // Review-only catalog: no product publication or cart controls.
    const root = document.querySelector('[id^="NewRegionalStatic-"]');
    const params = new URLSearchParams(location.search);
    if (root && params.get('new-regional-preview') === '1') {
      const handle = params.get('new-regional-product');
      const product = data.p[handle];
      if (product) {
        const color = root.querySelector('[data-product-color]');
        const image = root.querySelector('.new-regional-static__product-image');
        const badge = swatch();
        color.closest('label').after(badge);
        const status = document.createElement('p');
        status.className = 'fia-photo-message';
        status.setAttribute('role', 'status');
        status.hidden = true;
        image.after(status);
        const showMissing = (value, text) => {
          image.hidden = true;
          image.removeAttribute('src');
          image.alt = '';
          status.textContent = text + ' ' + value + '.';
          status.hidden = false;
        };
        const sync = () => {
          const value = color.value;
          paint(badge, value);
          const entry = product.colors[value];
          const source = entry && entry[0] >= 0 ? data.u[entry[0]] : null;
          image.dataset.selectedColor = value;
          if (!source) return showMissing(value, 'Matching product photo needed for');
          status.hidden = true;
          image.hidden = false;
          image.alt = root.querySelector('[data-product-title]').textContent + ' — ' + value;
          image.src = source;
        };
        image.addEventListener('error', () => showMissing(color.value, 'Unable to load the matching product photo for'));
        color.addEventListener('change', sync);
        sync();
        root.dataset.colorImagesReady = 'true';
      }
      root.dataset.colorAuditReady = 'true';
    }

    // Real staged product template: native Shopify variants handle image and price changes.
    document.querySelectorAll('[data-fia-native-color]').forEach(marker => {
      const product = data.p[marker.dataset.productHandle];
      const scope = marker.closest('product-info') || marker.closest('.shopify-section');
      if (!product || !scope) return;
      const sync = () => {
        const color = scope.querySelector('variant-selects select[name="options[Color]"]');
        if (!color) return;
        const input = color.closest('.product-form__input');
        if (!input) return;
        let badge = input.querySelector('.fia-selected-color');
        if (!badge) { badge = swatch(); input.append(badge); }
        if (badge.dataset.color !== color.value) {
          paint(badge, color.value);
          badge.dataset.color = color.value;
        }
        const urls = new Set(Object.values(product.colors).filter(v => v[0] >= 0).map(v => data.u[v[0]].split('/').pop().split('?')[0]));
        scope.querySelectorAll('media-gallery li img').forEach(img => {
          if (urls.has((img.currentSrc || img.src).split('/').pop().split('?')[0])) {
            const slide = img.closest('li');
            if (slide.hidden) { slide.hidden = false; slide.removeAttribute('aria-hidden'); }
          }
        });
      };
      scope.addEventListener('change', sync);
      const observer = new MutationObserver(sync);
      observer.observe(scope, { childList: true, subtree: true });
      sync();
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
